import React from 'react'
import Logo from '../../assets/fareye-logo.json'
import { Modal, styled, Span, Flex } from '@fareye/ui'
import { TimeZoneList, TIMEZONE_KEY, useTimeZone } from '../..'
import { FaCheck, FaChevronRight, tzFormat } from '@fareye/utils'
import { timeZoneList } from '../../modules/Timezone'
import enUS from 'date-fns/locale/en-US'

const LogoWithDropDown = styled.div`
  position: relative;
  margin: 0 auto;
  &:after {
    content: '';
    position: absolute;
    bottom: 15px;
    right: 0px;
    padding: 3px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    border-right: 2px solid #324554;
    border-bottom: 2px solid #324554;
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
  }
  &:hover {
    > div {
      opacity: 1;
    }
  }
  img {
    height: auto;
    width: 15vmax;
    padding: 0 15px;
  }
`

const SubMenu = styled(Flex)`
  padding: 5px 0 0;
  user-select: none;
  opacity: 0;
  min-width: 160px;
  border: 2px solid transparent;
  background: #fff;
  border-radius: 4px;
  position: absolute;
  left: 100%;
  top: 0px;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  box-shadow: 0 1px 5px rgb(204 204 204);
  &::after {
    position: absolute;
    content: ' ';
    left: 100%;
    top: 0;
    width: 10px;
    height: 100%;
  }
  &:hover {
    opacity: 1;
    transition: 0.6s ease;
  }
  a,
  span {
    padding: 1px 10px;
    border-radius: 0;
    transition: 0.6s ease;
    justify-content: flex-start;
    color: ${(props: any) => props.bg || props.theme.colors.primary};
    > svg {
      transition: 0.6s ease;
      margin-right: 10px;
      color: ${(props: any) => props.bg || props.theme.colors.primary};
    }
    &:hover {
      background: ${(props: any) => props.bg || props.theme.colors.primary};
      color: #fff;
      transition: 0.8s ease;
      > svg {
        transition: 0.8s ease;
        color: #fff;
      }
      > div {
        opacity: 1;
        transition: 0.6s ease;
      }
    }
  }
`

export function PublicHeader() {
  const [timeZoneModal, setTimeZoneModal] = React.useState(false)
  const { state, setState } = useTimeZone()
  function handleClick(ele: any) {
    let data = {
      id: ele.abbr,
      text: ele.text,
      value: ele.value,
      displayText: ele.text
    }
    setState(data)
    localStorage.setItem(TIMEZONE_KEY, JSON.stringify(data))
  }
  const TZ_DISPLAY = () =>
    tzFormat(new Date(), 'z', {
      timeZone: state.value || 'GMT',
      locale: enUS
    })
  return (
    <LogoWithDropDown>
      <img
        src={Logo.logo}
        alt="fareye-logo"
        // onClick={() => setTimeZoneModal(!timeZoneModal)}
      />
      <SubMenu column className="sub-menu">
        {timeZoneList.map((ele: any, index) => {
          let selected = ele.id === state.id
          return (
            <Span key={`${ele.text}-${index}`} onClick={() => handleClick(ele)}>
              {ele.text}
              {selected ? (
                <FaCheck
                  size={10}
                  style={{
                    margin: 'auto',
                    padding: '3px 0 0 10px',
                    height: 10
                  }}
                />
              ) : null}
            </Span>
          )
        })}
        <Span onClick={() => setTimeZoneModal(true)}>
          {state.id === 'others' ? TZ_DISPLAY() : 'Others'}
          <FaChevronRight style={{ marginLeft: 10 }} />
          {state.id === 'others' ? (
            <FaCheck
              size={10}
              style={{
                margin: 'auto',
                padding: '3px 0 0 10px',
                height: 10
              }}
            />
          ) : null}
        </Span>
      </SubMenu>
      {timeZoneModal && (
        <Modal
          variant="l"
          toggleModal={timeZoneModal}
          setToggleModal={setTimeZoneModal}
        >
          <TimeZoneList
            setToggleModal={setTimeZoneModal}
            state={state}
            setState={setState}
          />
        </Modal>
      )}
    </LogoWithDropDown>
  )
}
